import { observable } from 'mobx'

class SearchState {
  @observable isSearchFocused = false

  setSearchFocused = isFocused => {
    this.isSearchFocused = isFocused
  }
}

const searchState = new SearchState()
export default searchState
export { searchState }
